import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import AddressByZipCodeApi from '../api/AddressByZipCodeApi';

class AddressByZipCode extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.clearAddress = this.clearAddress.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        this.handleAddress2Change = this.handleAddress2Change.bind(this);
        this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.validate = this.validate.bind(this);

        this.state = this.getInitializedStateObject();

    }

    getInitializedStateObject() {
        return {
            address1: "",
            address1Valid: true,
            address2: "",
            zipCode: "",
            zipCodeValid: false,
            zipCodeValidation: true,
            city: "",
            cityValid: true,
            state: "",
            stateValid: true,
            addresses: null,
            useInputMask: false,
            county: "",
            countryRegion: ""
        };
    }

    clearAddress() {
        this.setState(this.getInitializedStateObject());
    }

    setAddress() {
        var address = {
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city,
            state: this.state.state,
            zipCode: this.state.zipCode,
            county: this.state.county,
            countryRegion: this.state.countryRegion
        };
        this.props.setAddress(address);
    }

    handleAddress1Change(e) {
        var val = e.target.value;
        this.setState({
            address1: val,
            address1Valid: true
        }, () => { this.setAddress(); });
    }

    handleAddress2Change(e) {
        var val = e.target.value;
        this.setState({
            address2: val
        }, () => { this.setAddress(); });
    }

    handleZipCodeChange(e) {
        var val = e.target.value;
        var useInputMask = val && val.length;
        this.setState({
            zipCode: val,
            zipCodeValidation: true,
            cityValid: true,
            stateValid: true,
            useInputMask: useInputMask
        });
        if (val && val.length && val.indexOf("_") === -1) {
            AddressByZipCodeApi.getAddresses(val).then(response => {
                if (response && response.length === 1) {
                    this.setState({
                        city: response[0].city,
                        state: response[0].state,
                        county: response[0].county,
                        countryRegion: response[0].countryRegion,
                        zipCodeValid: true
                    }, () => { this.setAddress(); });
                }
                else if (response && response.length) {
                    this.setState({
                        addresses: response,
                        zipCodeValid: true,
                        state: response[0].state,
                        county: response[0].county,
                        countryRegion: response[0].countryRegion,
                    }, () => { this.setAddress(); });
                }
                else {
                    this.setState({
                        addresses: null,
                        zipCodeValid: false,
                        city: "",
                        state: ""
                    }, () => { this.setAddress(); });
                }
            }).catch(error => {
                console.log(`Error retrieving city and state for zipcode: ${val}`);
            });
        }
        else {
            this.setState({
                addresses: null,
                zipCodeValid: false,
                city: "",
                state: ""
            }, () => { this.setAddress(); });
        }
    }

    handleCityChange(e) {
        var val = e.target.value;
        this.setState({
            city: val
        }, () => { this.setAddress(); });
    }

    handleStateChange(e) {
        var val = e.target.value;
        this.setState({
            state: val
        }, () => { this.setAddress(); });
    }

    validate() {
        var address1Valid = !!this.state.address1 && this.state.address1.length;
        var zipCodeValidation = !!this.state.zipCode && this.state.zipCode.indexOf("_") === -1 && this.state.zipCode.length === 5;
        var cityValid = !!this.state.city && this.state.city.length;
        var stateValid = !!this.state.state && this.state.state.length;

        this.setState({
            address1Valid: address1Valid,
            zipCodeValidation: zipCodeValidation,
            cityValid: cityValid,
            stateValid: stateValid
        });

        return address1Valid && zipCodeValidation && cityValid && stateValid;
    }

    renderCitiesFromAddresses() {
        var selectOptions = [];
        if (this.state.addresses) {
            this.state.addresses.map((address, index) => {
                selectOptions.push(<option key={address.city} value={address.city}>{address.city}</option>);
            });
        }
        return selectOptions;
    }

    render() {
        return (
            <div className="address-container">
                <FormGroup controlId="address1" validationState={this.state.address1Valid ? null : "error"}>
                    <div className="col-md-12">
                        <FormControl
                            type="text"
                            value={this.state.address1}
                            onChange={this.handleAddress1Change}
                            placeholder="Address Line 1"
                        />
                    </div>
                </FormGroup>
                {
                    !this.state.address1Valid &&
                    <div className="row">
                        <div className="col-md-12 text-left">
                            <span className="text-danger">Address Line 1 is required!</span>
                        </div>
                    </div>
                }
                <FormGroup controlId="address2">
                    <div className="col-md-12">
                        <FormControl
                            type="text"
                            value={this.state.address2}
                            onChange={this.handleAddress2Change}
                            placeholder="Address Line 2 (optional)"
                        />
                    </div>
                </FormGroup>
                <FormGroup controlId="zipCityState">
                    <div className={this.state.zipCodeValidation ? "col-md-4" : "col-md-4 has-error"}>
                        <InputMask
                            className="form-control"
                            mask={this.state.useInputMask ? "99999" : null}
                            placeholder="Zip Code"
                            type="text"
                            value={this.state.zipCode}
                            onChange={this.handleZipCodeChange}
                        />
                    </div>
                    <div className={this.state.cityValid ? "col-md-5" : "col-md-5 has-error"}>
                        {
                            this.state.addresses && this.state.addresses.length > 1 ?
                                <FormControl componentClass="select" placeholder="Select City..."
                                    type="select"
                                    value={this.state.city}
                                    onChange={this.handleCityChange}
                                >
                                    <option key="none" value="none">Select City...</option>
                                    {this.renderCitiesFromAddresses()}
                                </FormControl> :
                                    <FormControl
                                        type="text"
                                        value={this.state.city}
                                        onChange={this.handleCityChange}
                                        placeholder="City"
                                        disabled={this.state.zipCodeValid}
                                />
                        }
                    </div>
                    <div className={this.state.stateValid ? "col-md-3" : "col-md-3 has-error"}>
                        <FormControl
                            type="text"
                            value={this.state.state}
                            onChange={this.handleStateChange}
                            placeholder="State"
                            disabled={this.state.zipCodeValid}
                        />
                    </div>
                </FormGroup>
                {
                    (!this.state.zipCodeValidation || !this.state.cityValid || !this.state.stateValid) &&
                    <div className="row">
                        {
                            !this.state.zipCodeValidation &&
                            <div className="col-md-4 text-left">
                                <span className="text-danger">Zip Code is required!</span>
                            </div>
                        }
                        {
                            !this.state.cityValid &&
                            <div className={!this.state.zipCodeValidation ? "col-md-5 text-left" : "col-md-offset-4 col-md-5 text-left"}>
                                <span className="text-danger">City is required!</span>
                            </div>
                        }
                        {
                            !this.state.stateValid &&
                            <div
                                className={
                                    !this.state.zipCodeValidation ?
                                        !this.state.cityValid ?
                                            "col-md-3 text-left" :
                                            "col-md-offset-5 col-md-3 text-left" :
                                        "col-md-offset-9 col-md-3 text-left"
                                }
                            >
                                <span className="text-danger">State is required!</span>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default AddressByZipCode;